// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getFeaturedProducts } from "@guestsupply/App/Services/ProductService";
import { CustomAppState } from "@guestsupply/App/Store/Reducers";
import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import { ProductCollectionModel } from "@insite/client-framework/Types/ApiModels";

export interface FeaturedProductsModel {
    productNumbers: string;
}
type HandlerType = ApiHandler<FeaturedProductsModel, ServiceResult<ProductCollectionModel>>;

export const RequestDataFromApi: HandlerType = async props => {
    const productNumbers = `productNumbers=${props.parameter.productNumbers.replace(/,/g, "&productNumbers=")}`;
    const featuredProductsObject = (props.getState() as CustomAppState).xFeaturedProducts.featuredProducts;

    // to prevent more than one API call
    if (featuredProductsObject[props.parameter.productNumbers]) {
        return;
    }
    props.dispatch({
        type: "xProductList/BeginLoadingFeaturedProducts",
    } as any);

    try {
        props.apiResult = await getFeaturedProducts({ productNumbers, page: 1, pageSize: 5 });
    } catch (error) {
        props.dispatch({
            type: "xProductList/FeaturedProductsError",
            error: error?.errorMessage,
        } as any);
    }
};
export const DispatchSetFeaturedProductsData: HandlerType = props => {
    const featuredProductsObject = (props.getState() as CustomAppState).xFeaturedProducts.featuredProducts;

    if (featuredProductsObject[props.parameter.productNumbers]) {
        return;
    }

    if (props.apiResult.successful) {
        props.dispatch({
            type: "xProductList/SetFeaturedProducts",
            featuredProducts: props.apiResult.result.products ?? [],
            productNumbers: props.parameter.productNumbers,
        } as any);
    }
    props.dispatch({
        type: "xProductList/EndLoadingFeaturedProducts",
    } as any);
};

export const chain = [RequestDataFromApi, DispatchSetFeaturedProductsData];

const loadFeaturedProducts = createHandlerChainRunner(chain, "loadFeaturedProducts");

export default loadFeaturedProducts;
